/**
 * InviteStudentMembers for a group
 */

import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Button, Card } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import Spinner from 'components/Spinner/index.jsx';
import { idValues } from 'utils/arrays.js';
import image from './student.png';
import messages from '../messages.js';
import InviteStudentsModal from './InviteStudentsModal.jsx';

const Img = styled.img`
  height: 40px;
`;
function InviteStudentMembers(props) {
  const { students, className } = props;
  const [show, setShow] = useState(false);
  const { hasMore, totalCount } = students;
  const loading = hasMore !== false;
  const counts = useMemo(() => {
    const result = { totalCount, activeCount: 0, unconnectedCount: 0, studentCount: 0, parentCount: 0 };
    if (loading) {
      return result;
    }
    idValues(students).forEach((student) => {
      const { uniqueId, connectionCount } = student;
      if (uniqueId) {
        result.activeCount++;
      } else if (connectionCount === 0) {
        result.unconnectedCount++;
      } else {
        result.studentCount++;
        result.parentCount += connectionCount;
      }
    });
    return result;
  }, [loading]);

  if (totalCount === 0) {
    return null;
  }
  return (
    <Card className={className}>
      <Card.Body className="d-flex align-items-center">
        <Img src={image} className="me-3" alt="" />
        {loading ? <Spinner /> : (
          <>
            <div className="flex-grow-1">
              <div className="fw-semibold">
                <FormattedMessage {...messages.activeStudents} values={counts} />
              </div>
              <div><FormattedMessage {...messages.studentsUseSocs} /></div>
            </div>
            <Button variant="light" onClick={() => setShow(true)}>
              <FormattedMessage {...messages.inviteStudents} />
            </Button>
          </>
        )}
        <InviteStudentsModal show={show} onHide={() => setShow(false)} students={students} counts={counts} />
      </Card.Body>
    </Card>
  );
}

InviteStudentMembers.propTypes = {
  students: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default InviteStudentMembers;
